import { cssToken } from '@youhelp-ru/ui';
import { SxProps } from '@mui/material';

export const AUDIO_PLAYER_SIZE = ['normal', 'small'] as const;
export const AUDIO_THEME = ['normal', 'dark'] as const;

export type AudioPlayerSize = (typeof AUDIO_PLAYER_SIZE)[number];
export type AudioPlayerTheme = (typeof AUDIO_THEME)[number];

export interface AudioPlayerOwnState {
  size?: AudioPlayerSize;
}

export type AudioPlayerOwnerState = Required<AudioPlayerOwnState>;

export type AudioPlayerProps = AudioPlayerOwnState & {
  source: string;
  duration?: number;
  onClick?: () => void;
  autoPlay?: boolean;
  sx?: SxProps;
  frozenDuration?: boolean;
};

export interface AudioPlayerRef {
  play: () => void;
  pause: () => void;
  setTime: (time: number) => void;
}

export type ViewProps = AudioPlayerOwnerState &
  Omit<AudioPlayerProps, 'source'> & {
    onPlay: () => void;
    progress: number;
    audioDuration: string | null;
    isPaused: boolean;
  };

export const AudioPlayerCSSTokens = {
  TrackColor: cssToken('AudioPlayerTrack', 'Color'),
} as const;
